import { PMT } from "../classes/Enum"

const PaymentMethodComponent = ({setPaymentMethod, shippingOption}) => {
    return <div className="shipping-container">
        <h2>3. Payment Options</h2>

        {(shippingOption !== null) &&
        <div className="payment-method">
            <button onClick={() => setPaymentMethod(PMT.CARD)}>
                <img src="/assets/svgs/card.svg"></img>
            </button>
            <h3 className="h3-padding">|</h3>
            <button onClick={() => setPaymentMethod(PMT.PAYID)}>
                <img src="/assets/imgs/pay_id.png"></img>
            </button>
        </div>
        }
    </div>
}

export default PaymentMethodComponent